import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SICUDSIC_TBl;

export default {
  post(payload) {
    return baseApi.post(resource, payload);
  },

  delete(payload) {
    return baseApi.delete(resource, { data: payload });
  },

  put(payload) {
    return baseApi.put(resource, payload);
  },
};
